import { useMemo } from "react"
import { Outlet } from "@tanstack/react-router"

import { ENABLE_LANDING_PAGES } from "#/shared/constants"
import { useLandingRoute, useMobileScreen } from "#/shared/hooks"

import Header from "../../ui-old/Layout/Header"
import MobileView from "../Layout/MobileView"

import DappContainer from "./DappContainer"

export default function AppContainer() {
  const isMobileScreen = useMobileScreen()
  const { isLandingRoute } = useLandingRoute()

  const showMobileView = useMemo(() => {
    if (ENABLE_LANDING_PAGES) {
      return isMobileScreen && !isLandingRoute
    }
    return isMobileScreen
  }, [isMobileScreen, isLandingRoute])

  if (showMobileView) {
    return <MobileView />
  }

  if (ENABLE_LANDING_PAGES && isLandingRoute) {
    return (
      <>
        <Header />
        <Outlet />
      </>
    )
  }

  return <DappContainer />
}
